<template>
  <el-container style="display: block">
    <headers></headers>
    <el-container
      style="
        min-height: 600px;

        width: 1300px;
        margin: auto;
      "
    >
      <el-aside width="205px" style="background: #fff">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-vertical-demo"
          text-color="#303133"
          active-text-color="#409EFF"
          :unique-opened="true"
          router
          ref="elMenu"
        >
          <!-- 递归动态菜单 -->
          <myitem></myitem>
        </el-menu>
      </el-aside>

      <div class="info-div">
        <div class="psonCenter">
          <div class="psonLeft">
            <a href="/member/index/baseinfo.html" class="leftImg">
              <img width="100px" src="http://www.zaoge.com/res/images/default.png" />
            </a>
            <div class="centerTxt" style="position: relative">
              <div class="leftTxt">
                <span
                  ><font><!-- 17608212867/ -->{{ userInfo.nick_name }}</font>
                  <!--<img src="//zuhaowan.zuhaowan.com/v1/images/user_dengji.png" alt="用户等级" class="dengji"/>
						<img alt="用户信誉积分" src="//zuhaowan.zuhaowan.com/v1/images/user_xinyu.png" class="xinyu"/>-->
                </span>
                <!--<div class="creditRateBox xinyujifen">
						<div class="creditRate">
							<div class="creditTxt">用户信誉等级</div>
							<p>81积分</p>
							<a href="/Member/User/credit.html" target="_blank" class="btn">提升信誉</a>
						</div>
					</div>-->

                <div
                  class="creditRateBox userdengji"
                  style="display: none; height: 0px"
                ></div>
              </div>
              <div class="leftTxt2">账号安全：</div>
              <div class="safeline">
                <a href="/member/index/baseinfo/tab/2.html">
                  <span class="safe" style="width: 100%"></span>
                  <span class="safebottom"></span>
                  <font color="#2196f3" style="font-size: 12px; color: #2196f3"
                    >安全</font
                  >
                </a>
              </div>

              <!--信誉等级入口-->
              <div class="credit">
                <div style="float: left">信誉积分：</div>
                <div class="credit_zt">
                  <input
                    type="text"
                    value="81"
                    id="integral"
                    style="display: none"
                  />
                  <input
                    type="text"
                    value="60"
                    id="warn_score"
                    style="display: none"
                  />
                  <span class="span_a jc">81</span>
                </div>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="psonRight" style="display: none">
            <div class="rightMoney" style="margin-left: 10px">
              <a href="/funds/index.html">
                <div class="moneyYE">可用余额</div>
                <div class="moneyYE2">￥0.00</div>
              </a>
            </div>
            <div class="moneyLine"></div>

            <div class="rightMoney" >
              <div class="moneyYE">
                不可用余额<img
                  src="//zuhaowan.zuhaowan.com/v1/images/whao.png"
                  class="notip"
                />
              </div>
              <div class="fExplain" style="display: none">
                <span class="fExplainSp"></span>
                不可用包括正在提现、正在结算、投诉冻结和保障押金等金额。
              </div>
              <div class="moneyYE2">￥0.00</div>
            </div>

            <div class="moneyLine"></div>
            <div class="rightMoney">
              <a href="/member/user/hongbao.html">
                <div class="moneyYE">红包</div>
                <div class="moneyYE2">￥0.00</div>
              </a>
            </div>
            <!--<el-button type="success" round><img src="/static/images/psonHZ_57.png" alt="" /> 充值</el-button>-->
            <div class="clear"></div>
            <div class="orderMy">
              今日我的订单<a href="/user/#order"><span>0</span></a>
            </div>
            <div class="orderMy">
              本月订单<a href="/user/#order"><span>0</span></a>
            </div>
            <div class="orderMy">
              历史下单<a href="/user/#order"><span>0</span></a>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="Main_right_bottoml">
          <div class="orderlist">
            <div class="list_title">
              <span><i class="tenant_collect"></i>我收藏的logo</span>
              <router-link to="/collect">更多&gt;&gt;</router-link>
            </div>
            <div class="collect-div">

                           <div class="collect-li" v-for="item in collectLsit" :key="item.index">
                            <router-link :to="'/logo/logoDetail.html?GoodsId='+item.goodsId+'&mandate='+item.mandate+'&BrandName='+item.brandName+'&slogan='+item.slogan" >
                              
                <el-image :src="item.url.replace('https://logo.aliyun.com/logo/image','https://s.zaoge.com/logo/get_alilogo.php')" alt="" srcset=""/>
              </router-link>
              </div>
            </div>
            <div class="list_con" v-show="!collectLsit">
              <div class="ordernull">
                <img src="//zuhaowan.zuhaowan.com/v1/images/null.png" />
                <p>这里空空的~您当前还没有收藏过logo哦~</p>
                <a href="/">去看看</a>
              </div>
            </div>

          </div>
        </div>
           <div class="Main_right_bottoml">
          <div class="orderlist">
            <div class="list_title">
              <span><i class="tenant_collect"></i>我的足迹</span>
              <router-link to="/view">更多&gt;&gt;</router-link>
            </div>
            <div class="collect-div">

             <div class="collect-li" v-for="item in viewLsit" :key="item.index">
                            <router-link :to="'/logo/logoDetail.html?GoodsId='+item.goodsId+'&mandate='+item.mandate+'&BrandName='+item.brandName+'&slogan='+item.slogan" >
                              
                <el-image :src="item.url.replace('https://logo.aliyun.com/logo/image','https://s.zaoge.com/logo/get_alilogo.php')" alt="" srcset=""/>
              </router-link>
              </div>
            </div>
            <div class="list_con" v-show="!viewLsit">
              <div class="ordernull">
                <img src="//zuhaowan.zuhaowan.com/v1/images/null.png" />
                <p>这里空空的~您当前还没有浏览过logo哦~</p>
                <a href="/">去看看</a>
              </div>
            </div>

          </div>
        </div>
      </div>

    </el-container>
  </el-container>
</template>

<script>
import headers from "../components/header"; // 引入头部
import myitem from "../components/myitem"; // 引入递归菜单组件
import { getApi, postApi, postApiJson } from "../../utils/request";

export default {
  data() {
    return {
      activeIndex: this.$route.path,
      userInfo: "",
      collectLsit: null,
      viewLsit: null,
    };
  },
  created: function () {
    this.getDetail();
    this.getCollectList();
    this.getViewList()
  },
  methods: {
    // 获取详情数据
    getDetail() {
      getApi("/logoapi/get_myself_info").then((res) => {
        console.log(res.data.data[0]);
        this.userInfo = res.data.data[0];
      });
    },
    // 获取收藏列表
    getCollectList() {
      postApiJson("/logoapi/logo_collect_list", {
        limit:'8'
      }).then((res) => {
        console.log(res.data.success);
        if (res.data.success) {
          this.collectLsit = res.data.data;
        }
      });
    },
    // 获取足迹列表
    getViewList() {
      postApiJson("/logoapi/logo_view_list", {
        limit:'8'
      }).then((res) => {
        console.log(res.data.success);
        if (res.data.success) {
          this.viewLsit = res.data.data;
        }
      });
    },
  },

  components: { myitem, headers },
};
</script>


<style scoped>
body {
  background-color: #f9f9f9;
}

.info-div {
  text-align: center;
  width: 100%;
  margin-left: 10px;
}

.psonCenter {
  width: 99%;
  height: 150px;
  background: #fff;
  margin-bottom: 10px;
}
.psonCenter .psonLeft {
  width: 310px;
  padding: 20px 5px 20px 30px;
  float: left;
}
.psonLeft .leftImg {
  width: 100px;
  height: 100px;
  display: block;
  float: left;
  overflow: hidden;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  -o-border-radius: 50%;
  -ms-border-radius: 50%;
}
.psonLeft .leftImg img {
  border-radius: 50px;
}
.psonLeft .leftImg img {
  width: 100px;
  height: 100px;
}
.leftImg i {
  position: absolute;
  bottom: -10px;
  width: 100px;
  height: 22px;
  left: 0;
  text-align: center;
}
.psonLeft .centerTxt {
  padding-left: 30px;
  text-align: left;
  font-size: 13px;
  color: #555;
}
.psonLeft .leftTxt {
  width: 100%;
  height: 35px;
  line-height: 35px;
  position: relative;
  font-size: 14px;
  font-weight: bold;
}
.psonLeft .leftTxt2 {
  width: 100%;
  height: 28px;
  line-height: 28px;
  font-size: 13px;
}
.safeline {
  position: absolute;
  width: 50px;
  height: 25px;
  line-height: 25px;
  display: inline-block;
  top: 29px;
  left: 161px;
}
.safeline span.safe {
  background: #2196f3;
  z-index: 1;
}
.safeline span {
  width: 50px;
  height: 8px;
  position: absolute;
  top: 17px;
  left: 0px;
}
.safeline font {
  display: inline-block;
  line-height: 25px;
  position: absolute;
  top: 8px;
  left: 55px;
  width: 60px;
}
.credit {
  width: 100%;
  height: 28px;
  line-height: 28px;
  font-size: 13px;
  margin-bottom: 3px;
}
.psonCenter .psonRight {
  padding: 25px 5px;
  float: left;
  position: relative;
}
.psonRight .rightMoney {
  width: 110px;
  float: left;
}
.rightMoney {
  position: relative;
}
.psonRight .moneyYE,
.psonRight .moneyYE2 {
  width: 100%;
  line-height: 23px;
  color: #555;
  text-align: center;
  font-size: 14px;
}
.psonRight .moneyYE2 {
  color: #2196f3;
}
.psonRight .moneyLine {
  width: 1px;
  height: 40px;
  background: #f3f3f3;
  margin: 0 5px;
  float: left;
}
.psonRight .orderMy {
  width: 185px;
  height: 42px;
  line-height: 42px;
  float: left;
  margin: 15px 0 0 1px;
  background: #f6f6f6;
  text-align: center;
  font-size: 14px;
  color: #555;
}
.psonRight .orderMy span {
  margin: 0px 5px;
  color: #2196f3;
  border-bottom: 1px solid #2196f3;
}
.Main_right_bottoml {
  width: 659px;
  min-height: 305px;
  float: left;
  margin-top: 10px;
}
.Main_right_bottoml {
  width: 100% !important;
}
.Main_right_bottoml .orderlist {
  background: #fff;
  padding: 15px;
  min-height: 410px;
}
.Main_right_bottoml .orderlist {
  width: 97%;
  
}
.fl {
  float: left;
}
.fr {
  float: right;
}

.Main_right_bottoml .orderlist .list_title {
  height: 42px;
  line-height: 42px;
  border-bottom: 1px solid #e9e9e9;
  position: relative;
}
.Main_right_bottoml .orderlist .list_title span {
  display: inline-block;
  font-size: 14px;
  color: #666;
  line-height: 42px;
  font-weight: bold;
}
.orderlist .list_title span {
  border-bottom: 1px solid #2196f3;
  padding: 0 10px;
  position: relative;
  float: left;
}
.Main_right_bottoml .orderlist .list_title a {
  display: inline-block;
  position: absolute;
  right: 0px;
  font-size: 12px;
  line-height: 42px;
  color: #666;
}
.Main_right_bottoml .orderlist .list_con {
  padding: 6px 0px;
}
.Main_right_bottoml .orderlist .list_con table tr td {
  padding: 13px 2px;
  border-bottom: 1px dashed #e8e8e8;
  text-align: left;
}
.Main_right_bottoml .img_tle {
  width: 70px;
}
.Main_right_bottoml .orderlist .list_con table tr td.title p.order_id {
  width: 285px !important;
}
.Main_right_bottoml .orderlist .list_con table tr p {
  font-size: 13px;
  line-height: 24px;
}
.Main_right_bottoml .orderlist .list_con table tr td.title p.serve {
  display: block;
  width: 210px;
  overflow: hidden;
  height: 25px;
}
.Main_right_bottoml .orderlist .list_con .ordernull {
  padding: 46px 15px;
  text-align: center;
}
.Main_right_bottoml .orderlist .list_con .ordernull p {
  font-size: 14px;
  color: #c1c1c1;
  line-height: 22px;
  padding: 15px 0px;
}
.Main_right_bottoml .orderlist .list_con .ordernull a {
  color: #2196f3;
  border: 1px solid #2196f3;
  border-radius: 30px;
  width: 100px;
  height: 30px;
  line-height: 30px;
  display: inline-block;
  margin-top: 2px;
}
.collect-div{
  display: grid;
  padding: 10px;
  grid-template-columns: 300px 300px 300px 300px;
  width: 100%;
}
.collect-div .collect-li{
  width: 90%;
  height: 200px;
  border: 1px dashed #999;
  border-radius: 10px;
  overflow: hidden;
  margin: 0 10px 10px 0;
}
.collect-div .collect-li :hover{

 box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}
.collect-div .collect-li img{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/main.vue